import { Badge, Icon } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

const STATUSES = {
  full: {
    icon: 'status active',
    color: 'Label-Confirm',
    bgColor: 'Background-Confirm',
  },
  read: {
    icon: 'status active',
    color: 'Label-GU-Primary',
    bgColor: 'Background-Quaternary',
  },
}

export const StatusBadge = ({ status = null, label, ...rest }) => {
  const currentStatus = useMemo(() => {
    switch (status) {
      case 'reports':
      case 'readonly':
      case 'fin_readonly':
      case 'ads_readonly':
        return STATUSES.read
      case 'manager':
      case 'full_access':
        return STATUSES.full
    }
  }, [status])

  const { t } = useTranslation()

  if (!currentStatus) {
    return null
  }

  const { icon, bgColor, color } = currentStatus

  return (
    <Badge
      {...rest}
      noWrap
      bgColor={bgColor}
      color={color}
      startIcon={
        <Icon
          color={color}
          name={icon}
          size={'s'}
        />
      }
    >
      {t(label)}
    </Badge>
  )
}

StatusBadge.propTypes = {
  label: PropTypes.string,
  status: PropTypes.string,
  className: PropTypes.string,
  component: PropTypes.elementType,
}
